(function () {
    "use strict";

    angular.module("app").directive("habilMonthPicker", MonthPickerDirectiveFactory);

    MonthPickerDirectiveFactory.$inject = ["$locale",];
    function MonthPickerDirectiveFactory($locale) {
        return {
            template: `
            <div class="input-group date">
                <input class="form-control"
                       ng-attr-placeholder="{{'DatePickerPlaceHolderOnlyMonthYear' | habilTranslation}}"
                       ng-model="ngModel"
                       ui-mask="99/9999"
                       model-view-value="true">
                <span class="input-group-addon">
                    <i class="fa fa-calendar"></i>
                </span>
            </div>
            `,
            require: { modelController: "^ngModel" },
            scope: {},
            link: initializeDatepicker,
        };

        function initializeDatepicker(scope, element, _attributes, controllers) {
            const options = {
                language: $locale.id,
                format: "mm/yyyy",
                assumeNearbyYear: true,
                minViewMode: 1,
                autoclose: true,
                clearBtn: true,
                orientation: "bottom",
                weekStart: 1,
            };

            const datepickerElement = $(element).children(".date");

            datepickerElement.datepicker(options);
            datepickerElement.bind('clearDate', onDateCleared);

            const ngModelCtrl = controllers.modelController;

            ngModelCtrl.$render = () => scope.ngModel = ngModelCtrl.$viewValue;
            scope.$watch(function () { return scope.ngModel; }, function (value) {
                ngModelCtrl.$setViewValue(value);
            });

            function onDateCleared() {
                scope.ngModel = null;
                scope.$apply();
            }            
        }
    }
})();